import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { GraduationCap, LayoutDashboard, BookOpen, Users, UserPlus, Settings, ArrowLeft, BadgeCheck } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useMySchoolMembership } from '@/hooks/useSchoolApi';

const NAV_ITEMS = [
  { to: '/school', label: 'Dashboard', icon: LayoutDashboard, end: true },
  { to: '/school/programs', label: 'Programs', icon: BookOpen },
  { to: '/school/cohorts', label: 'Cohorts', icon: GraduationCap },
  { to: '/school/requests', label: 'Join Requests', icon: UserPlus },
  { to: '/school/attestations', label: 'Attestations', icon: BadgeCheck },
  { to: '/school/staff', label: 'Staff', icon: Users },
];

export default function SchoolPortal() {
  const navigate = useNavigate();
  const { data: membership } = useMySchoolMembership();
  const schoolName = (membership as any)?.schools?.name || 'School Portal';

  return (
    <div className="min-h-screen bg-background">
      <header className="border-b bg-card px-4 py-3">
        <div className="container mx-auto flex items-center gap-3">
          <Button variant="ghost" size="icon" onClick={() => navigate('/passport')}>
            <ArrowLeft className="h-4 w-4" />
          </Button>
          <GraduationCap className="h-5 w-5 text-primary" />
          <h1 className="text-lg font-semibold">{schoolName}</h1>
        </div>
      </header>

      <div className="container mx-auto flex gap-6 p-4">
        {/* Sidebar nav */}
        <nav className="hidden md:flex flex-col gap-1 w-48 shrink-0">
          {NAV_ITEMS.map((item) => {
            // Hide staff for instructors
            if (item.to === '/school/staff' && membership?.role === 'instructor') return null;
            return (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                className={({ isActive }) =>
                  `flex items-center gap-2 rounded-md px-3 py-2 text-sm transition-colors ${
                    isActive ? 'bg-primary/10 text-primary font-medium' : 'text-muted-foreground hover:bg-muted'
                  }`
                }
              >
                <item.icon className="h-4 w-4" />
                {item.label}
              </NavLink>
            );
          })}
        </nav>

        {/* Main content */}
        <main className="flex-1 min-w-0">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
